import { Component } from '@angular/core';
import { AGENT_BUILDER_STEP_TITLE, ORGANIZATION_BUILDER_STEP_TITLE } from 'src/app/shared/constants/translations';
import { SharedStepperStep } from 'src/app/shared/shared-stepper/shared-stepper.component';

@Component({
  selector: 'app-organization-builder',
  templateUrl: './organization-builder.component.html',
  styleUrls: ['./organization-builder.component.scss'],
})
export class OrganizationBuilderComponent {
  steps: SharedStepperStep[] = [
    {
      label: 'personal',
      is_current: false,
      translation: AGENT_BUILDER_STEP_TITLE,
    },
    {
      label: 'organization',
      is_current: true,
      translation: ORGANIZATION_BUILDER_STEP_TITLE,
    },
  ];
}
